import { colorsPalettes } from "@similarweb/styles";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";
import { useFilteredChatbots } from "app/pages/digital-marketing/generative-ai/llm-tracker/homepage/hooks/useFilteredChatbots";
import type { ICampaignSettingField } from "app/pages/digital-marketing/generative-ai/llm-tracker/menu/types";
import { ModelSelector } from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/components/models-selector/ModelSelector";
import type { ExplicitLLModel } from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/types";
import CountryService from "app/services/CountryService";

interface IModelsSetting extends ICampaignSettingField {
    selectedModels: ExplicitLLModel[];
    setSelectedModels: (models: ExplicitLLModel[]) => void;
    countryCode: number;
    isLoading: boolean;
}

export const ModelsSetting = ({
    selectedModels,
    setSelectedModels,
    countryCode,
    isLoading,
    isReadOnly,
}: IModelsSetting) => {
    const selectedCountry = CountryService.getCountryById(countryCode);
    const { filteredChatbots, isLoading: isConfigLoading } = useFilteredChatbots(selectedCountry);

    return (
        <Flex
            flexDirection="column"
            gap="12px"
        >
            <Text
                fontVariant="subtitle2"
                color={colorsPalettes.carbon[500]}
            >
                {translate(
                    isReadOnly
                        ? "llmTracker.campaignQuery.edit.models.title.read-only"
                        : "llmTracker.campaignQuery.edit.models.title",
                )}
            </Text>
            <ModelSelector
                selectedModels={selectedModels}
                supportedModels={filteredChatbots}
                selectedCountry={selectedCountry}
                isLoading={isLoading || isConfigLoading}
                onChange={setSelectedModels}
                isReadOnly={isReadOnly}
            />
        </Flex>
    );
};
